export default [
  {
    path: '/reservation/fishing-spots',
    name: 'reservation-fishing-spots',
    component: () => import('@/views/pages/reservation/fishing-spot/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishing-spots',
      resource: 'reservation',
      action: 'list',
      breadcrumb: [
        {
          text: 'breadcrumb.list',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reservation/fishing-spots/add',
    name: 'add-reservation-fishing-spot',
    component: () => import('@/views/pages/reservation/fishing-spot/Add.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishing-spots',
      resource: 'reservation',
      action: 'create',
      breadcrumb: [
        {
          text: 'breadcrumb.add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reservation/fishing-spots/modify/:id',
    name: 'modify-reservation-fishing-spot',
    component: () => import('@/views/pages/reservation/fishing-spot/Modify.vue'),
    meta: {
      pageTitle: 'breadcrumb.fishing-spots',
      resource: 'reservation',
      action: 'edit',
      breadcrumb: [
        {
          text: 'breadcrumb.modify',
          active: true,
        },
      ],
    },
  },
]
